import { useMemo } from "react";

import { parseDiff, Diff, Hunk, type FileData } from "react-diff-view";
import { diffLines, formatLines } from "unidiff";

import { Card } from "#components/Card";
import "react-diff-view/style/index.css";

export interface DiffViewProps {
  /** The new string to diff */
  newStr: string | null;
  /** The old string to diff against */
  oldStr?: string | null;
  /** Number of lines of context to show around changes in diff view. Defaults to 3 */
  context?: number;
}

export function DiffView({ newStr, oldStr, context = 3 }: DiffViewProps) {
  const diffText = useMemo(() => {
    if (!newStr || !oldStr) {
      return null;
    }
    return formatLines(diffLines(oldStr, newStr), {
      context,
    });
  }, [context, oldStr, newStr]);

  if (!diffText) {
    return null;
  }

  const files = parseDiff(diffText);

  const renderFile = ({ oldRevision, newRevision, type, hunks }: FileData) => (
    <Diff diffType={type} hunks={hunks} key={oldRevision + "-" + newRevision} viewType="unified">
      {(hunks) => hunks.map((hunk) => <Hunk hunk={hunk} key={hunk.content} />)}
    </Diff>
  );

  return <Card className="text-mono-medium">{files.map(renderFile)}</Card>;
}
